module.exports = __webpack_public_path__ + "images/file_icons_v2/tiff-806814646827b28dd2063528614938a2.svg";